/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_App_UpdatesInputs */

const en_mobile_app_updates = /** @type {(inputs: Mobile_App_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App updates`)
};

const es_mobile_app_updates = /** @type {(inputs: Mobile_App_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones de la app`)
};

/**
* | output |
* | --- |
* | "App updates" |
*
* @param {Mobile_App_UpdatesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_app_updates = /** @type {((inputs?: Mobile_App_UpdatesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_App_UpdatesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_app_updates(inputs)
	return en_mobile_app_updates(inputs)
});